import React, { useState } from "react";
import styles from "./RsvpGuestTidbits.module.css";
import { Checkbox, Col, Layout, List, Radio, Row } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import bgcImage1 from "../../../../assets/bgcimage1.png";
import Rsvp from "../../../../assets/rsvp1.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { InputField, TextareaField } from "../../../../components";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

const RenderQuestions = ({ item, setAnswerByGuest, answerByGuest, i }) => {
  const onChangeCheck = (checkedValues) => {
    let arr = [...answerByGuest];
    arr[i].selected = [...checkedValues];
    setAnswerByGuest(arr);
  };

  const onChangeRadio = (e) => {
    let arr = [...answerByGuest];
    arr[i].selected = e.target.value;
    setAnswerByGuest(arr);
  };

  const onChangeText = (val) => {
    let arr = [...answerByGuest];
    arr[i].selected = val;
    setAnswerByGuest(arr);
  };
  return (
    <>
      <div className={styles.middlecontainer} key={item?.id}>
        <TextComponent text={item?.question} textClass={styles.text2} />
      </div>
      {item?.type == "Description" ? (
        <>
          <div>
            <TextareaField
              placeholder="Enter your desired answer"
              styles={styles.mainInput}
              value={answerByGuest[i]?.selected}
              onChange={(e) => onChangeText(e.target.value)}
            />
          </div>
        </>
      ) : item?.type == "Multiple Choice" ? (
        <Checkbox.Group style={{ width: "100%" }} onChange={onChangeCheck}>
          <Row>
            {item?.options?.map((data) => (
              <Col>
                <Checkbox value={data}>{data.name}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      ) : (
        <Radio.Group style={{ width: "100%" }} onChange={onChangeRadio}>
          <Row>
            {item?.options?.map((data) => (
              <Col>
                <Radio value={data}>{data.name}</Radio>
              </Col>
            ))}
          </Row>
        </Radio.Group>
      )}
    </>
  );
};

const RsvpTidbits = () => {
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  const [answerByGuest, setAnswerByGuest] = useState(
    rsvpData?.tidbits.map((item) => ({
      ...item,
      selected: null,
    }))
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myStyle = {
    backgroundImage: `url(${bgcImage})`,
    backgroundRepeat: "no-repeat",
  };
  const myStyle1 = {
    backgroundImage: `url(${bgcImage1})`,
    backgroundRepeat: "no-repeat",
  };

  const onSubmit = () => {
    let isvalid = true;
    // console.log("answerByGuest", answerByGuest);
    answerByGuest.forEach((element) => {
      if (!isvalid) {
        return;
      }
      // console.log(
      //   "!element?.selected || element?.selected?.length < 0",
      //   element?.selected
      // );
      if (!element?.selected || element?.selected?.length <= 0) {
        isvalid = false;
        dispatch(
          showAlert({
            type: "Error",
            message: "Please fill all the fields",
          })
        );
      }
    });
    if (isvalid) {
      navigate("/rsvp/rsvpQA", { state: { answerByGuest } });
    }
  };
  return (
    <div style={myStyle} className={styles.mainContainer}>
      <Header
        mainHeader={styles.headerColor}
        isProfile={true}
        title={"RSVP"}
        style={{ padding: 0, background: "var(--white-color)", height: 85 }}
        onBackClick={() => navigate(-1)}
      />

      <Row style={myStyle1} className={styles.mainDiv}>
        <Col xs={20} md={12} lg={8} className={styles.mainCol}>
          <TextComponent text={"Tidbits"} textClass={styles.text} />
          {/* <div className={styles.middlecontainer}>
            <TextComponent
              text={"How Did you first meet?"}
              textClass={styles.text2}
            />
          </div>

          <div className={styles.mainInput}>
            <textarea className={styles.textArea} placeholder="Write here...." />
            <InputField
              placeholder="Enter your desired answer"
              styles={styles.mainInput}
            />
          </div> */}
          <List
            dataSource={rsvpData?.tidbits}
            renderItem={(item, i) => (
              <RenderQuestions
                // key={item?.id}
                item={item}
                answerByGuest={answerByGuest}
                setAnswerByGuest={setAnswerByGuest}
                i={i}
              />
            )}
          />
          <BiSolidChevronRightCircle
            cursor={"pointer"}
            size={30}
            className={styles.icon}
            onClick={onSubmit}
          />
        </Col>
      </Row>
    </div>
  );
};

export default RsvpTidbits;
